import { render } from "./AdminVerification.vue?vue&type=template&id=653177e3&scoped=true"
import script from "./AdminVerification.vue?vue&type=script&lang=js"
export * from "./AdminVerification.vue?vue&type=script&lang=js"

import "./AdminVerification.vue?vue&type=style&index=0&id=653177e3&lang=css"
import "./AdminVerification.vue?vue&type=style&index=1&id=653177e3&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653177e3"]])

export default __exports__